"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Switch = void 0;
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
/**
 * Define default props here
 */
const defaultProps = {
    ariaLabel: 'Switch',
};
const ToggleInput = styled_components_1.default.input `
  /* visually hidden but still accessible */
  border: 0;
  clip: rect(0 0 0 0);
  height: 1px;
  margin: -1px;
  overflow: hidden;
  padding: 0;
  position: absolute;
  width: 1px;
  white-space: nowrap;

  &:focus + span::after {
    box-sizing: initial;
    box-shadow: 0 0 0 2px rgba(0, 0, 0, 0.1), 0 4px 0 rgba(0, 0, 0, 0.08),
      inset 0px 0px 0px 3px #9c9c9c;
  }
`;
const StyledToggleButton = styled_components_1.default('span') `
  box-sizing: initial;
  display: inline-block;
  outline: 0;
  width: 8em;
  height: 4em;
  position: relative;
  cursor: pointer;
  user-select: none;
  background: ${props => (props.isSwitchedOn ? '#86d993' : '#fbfbfb')};
  border-radius: 4em;
  padding: 4px;
  transition: all 0.4s ease;
  border: 2px solid #e8eae9;

  &::after {
    left: ${props => (props.isSwitchedOn ? '50%' : 0)};
    position: relative;
    display: block;
    content: '';
    width: 50%;
    height: 100%;
    border-radius: 4em;
    background: #fbfbfb;
    transition: all 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275),
      padding 0.3s ease, margin 0.3s ease;
    box-shadow: 0 0 0 2px rgba(0, 0, 0, 0.1), 0 4px 0 rgba(0, 0, 0, 0.08);
  }

  [disabled] {
    opacity: 0.7;
    cursor: auto;
  }
`;
/**
 * To suppress the warning of adding readonly to input checkbox field
 */
const noop = () => { };
/**
 * Primary UI component for user interaction
 */
const Switch = (_a) => {
    var { ariaLabel = defaultProps.ariaLabel, isSwitchedOn, onClick } = _a, props = __rest(_a, ["ariaLabel", "isSwitchedOn", "onClick"]);
    return (react_1.default.createElement("label", { "aria-label": ariaLabel },
        react_1.default.createElement(ToggleInput, { type: "checkbox", checked: isSwitchedOn, onChange: noop, onClick: onClick, "data-testid": "toggle-input" }),
        react_1.default.createElement(StyledToggleButton, Object.assign({ isSwitchedOn: isSwitchedOn }, props))));
};
exports.Switch = Switch;
//# sourceMappingURL=switch.js.map